function popup () {
    const popupShow = document.querySelectorAll('.popup-show');

    if(popupShow.length > 0) {
        const popup = document.querySelector('.popup');
        const popupContent = document.querySelectorAll('.popup__inner');
        const popupClose = document.querySelectorAll('.popup-close');

        popupShow.forEach(btn=> {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                popup.classList.add('show');
                document.body.style.overflow = 'hidden';

                //Получаем из кнопки категорию попапа который надо показать
                const popupCat = this.dataset.popup.toLowerCase();

                //Перебираем контент в попапе и показываем нужный
                popupContent.forEach(el=> {
                    if(el.dataset.popup.toLowerCase() === popupCat)
                        el.classList.add('show');
                });
            });
        });

        
        function closePopup () {
            popup.classList.remove('show');
            popupContent.forEach(el=> el.classList.remove('show'));
            document.body.style.overflow = 'initial';
        }

        popupClose.forEach(btn=> {
            btn.addEventListener('click', (e)=> {
                e.preventDefault();
                closePopup ();
            });
        });

        document.addEventListener('click', (e)=> {
            if(e.target && e.target.classList.contains('popup'))
                closePopup ();
        });
    }


    /**
     * Calc trigger
     */
    const calcTrigger = document.querySelector('.calculator-trigger');

    if (calcTrigger) {
        const triggerClose = document.querySelector('.calculator-trigger__close');
        const triggerShow = document.querySelector('.calculator-trigger__show');
        const storageKey = 'calculator-shown';

        // Закрытие калькулятора
        triggerClose.addEventListener('click', () => {
            calcTrigger.classList.remove('show');
            localStorage.setItem(storageKey, 'true');
        });

        // Установка ключа в localStorage при клике на кнопку
        triggerShow.addEventListener('click', () => {
            calcTrigger.classList.remove('show');
            localStorage.setItem(storageKey, 'true');
        });

        // Проверка localStorage при загрузке страницы
        if (!localStorage.getItem(storageKey)) {
            setTimeout(() => {
                calcTrigger.classList.add('show');
            }, 10000);
        }
    }
}

export default popup;